<section slimScroll [formGroup]="form" class="scroll-window sen-print-offer-general p-3">
    <sen-app-customer-data [type]=1></sen-app-customer-data>
    <mat-divider></mat-divider>
    <section fxLayout="row" class="p-2">
        <h4>{{translate.getLng('SETTINGS')}}</h4>
        <div class="mx-4" fxLayout="row" fxLayoutAlign="space-between top">
            <mat-radio-group class="d-block">
                <mat-radio-button value="1" class="d-block"> {{translate.getLng('PROPOS_SHORT')}}</mat-radio-button>
                <mat-radio-button value="2" class="d-block"> {{translate.getLng('DETAILED_OFFER')}}</mat-radio-button>
            </mat-radio-group>
            <mat-radio-group class="d-block ml-4">
                <mat-radio-button value="3" class="d-block"> {{translate.getLng('OFFER_PRICE')}}</mat-radio-button>
                <mat-radio-button value="4" class="d-block"> {{translate.getLng('ENTER_OFFER_PRICE')}}
                </mat-radio-button>
            </mat-radio-group>
        </div>
    </section>
    <mat-divider></mat-divider>
    <section class="py-2" fxLayout="row" fxLayoutAlign="space-between top">
        <div class="px-2" fxFlex="1 1 30%">
            <h4>{{translate.getLng('SHIPPING')}}</h4>
            <div class="ml-4 mt-4">
                <mat-checkbox> {{translate.getLng('TAI_LIF_NEED')}}</mat-checkbox>
                <mat-form-field class="d-block">
                    <mat-label>{{translate.getLng('SHIP_COST_CA')}}</mat-label>
                    <input matInput mask="000000">
                    <span matSuffix>&euro;</span>
                </mat-form-field>
            </div>
        </div>
        <mat-divider [vertical]="true"></mat-divider>
        <div class="px-2" fxFlex="1 1 30%">
            <h4>{{translate.getLng('MOUNTING')}}</h4>
            <div class="text-center">
                <p>{{translate.getLng('MOUNTING')}} (0 &euro;)</p>
                <mat-form-field class="w-50">
                    <input formControlName="mounting" mask="000000" matInput>
                    <span matSuffix>%</span>
                </mat-form-field>
            </div>
        </div>
        <mat-divider [vertical]="true"></mat-divider>
        <div class="px-2" fxFlex="1 1 40%">
            <h4>{{translate.getLng('PRICE_NET')}}</h4>
            <table class="ml-4">
                <tr>
                    <td class="text-right">{{translate.getLng('SEN_VK')}} : &nbsp;</td>
                    <td>20.366 &euro;</td>
                    <td></td>
                </tr>
                <tr>
                    <td></td>
                    <td class="pt-2" style="max-width:70px;overflow:hidden;">{{translate.getLng('MARGIN') }} : <br>
                        <mat-form-field class="w-75">
                            <input matInput mask="0000000">
                            <span matSuffix>%</span>
                        </mat-form-field>
                    </td>
                    <td></td>
                </tr>
                <tr class="font-weight-bold">
                    <td class="text-right text-nowrap">{{translate.getLng('CUST_VK')}} : &nbsp;</td>
                    <td>20.366 &euro;</td>
                    <td></td>
                </tr>
                <tr class="font-weight-bold">
                    <td class="text-right">{{translate.getLng('QUOTATION_PRICE')}} : &nbsp;</td>
                    <td>20.491 &euro; </td>
                    <td class="text-nowrap">(739 &euro; / kWp)</td>
                </tr>
            </table>
        </div>
    </section>
    <mat-divider></mat-divider>
</section>